module.exports = __webpack_public_path__ + "static/gorilla-thinking-5c56cd22ffaf2d3eddd02bca1e60552e.jpg";